/*
  JILZARAH — flashlight photo behaviour (COMPONENT layer; promoted from Halloween 2026 on 2026-09-04)

  Wires every [data-jz-flashlight] stage once: pointer position → --jz-fl-x/y on the stage.
  Desktop: move, with a little parallax. Touch: the light follows the finger the moment it
  lands on the photo, in any direction (touch-action: none on the stage, so the browser never
  turns a vertical drag on the photo into a page scroll — field feedback 2026-09-04: with pan-y
  a vertical first move scrolled the page and only a sideways start engaged the light). The page
  scrolls from anywhere outside the photo. Leaving the stage drifts the light back to rest.
  Honours prefers-reduced-motion. Safe under Theme Editor section reloads.
*/
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function wire(stage) {
    if (stage.dataset.jzFlWired) return;
    stage.dataset.jzFlWired = '1';
    var imgs = stage.querySelectorAll('.jz-fl__img');
    var touch = false;
    /* The mouse is tracked over the whole ARENA (the nearest [data-jz-flashlight-arena], e.g.
       the hero section) rather than just the stage, so crossing onto the button, the tiles or
       the copy panel keeps the light moving instead of resetting it. Touch stays on the stage. */
    var arena = stage.closest('[data-jz-flashlight-arena]') || stage;

    function move(ev) {
      var box = stage.getBoundingClientRect();
      var x = Math.max(0, Math.min(100, ((ev.clientX - box.left) / box.width) * 100));
      var y = Math.max(0, Math.min(100, ((ev.clientY - box.top) / box.height) * 100));
      stage.style.setProperty('--jz-fl-x', x + '%');
      stage.style.setProperty('--jz-fl-y', y + '%');
      if (!reduced && ev.pointerType !== 'touch') {
        var t = 'translate3d(' + (x / 100 - 0.5) * 9 + 'px, ' + (y / 100 - 0.5) * 7 + 'px, 0) scale(1.04)';
        imgs.forEach(function (i) { i.style.transform = t; });
      }
    }
    arena.addEventListener('pointermove', function (ev) {
      if (ev.pointerType === 'touch' && !touch) return; /* a finger that started off the photo */
      move(ev);
    });
    stage.addEventListener('pointerdown', function (ev) {
      if (ev.pointerType === 'touch') touch = true;
      move(ev);
    });
    stage.addEventListener('pointerup', function (ev) {
      touch = false;
    });
    stage.addEventListener('pointercancel', function () { touch = false; });
    arena.addEventListener('pointerleave', function (ev) {
      /* only a real exit from the arena resets; moving between its children does not */
      if (ev.relatedTarget && arena.contains(ev.relatedTarget)) return;
      touch = false;
      imgs.forEach(function (i) { i.style.transform = 'scale(1.025)'; });
      stage.style.removeProperty('--jz-fl-x');
      stage.style.removeProperty('--jz-fl-y');
    });
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-jz-flashlight]').forEach(wire); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (ev) { boot(ev.target); });
})();
